import * as React from 'react';
import { ArrowRightIcon, ArrowLeftIcon } from '@cvent/carina/components/Icon';
import { getMonthName } from '@weddingspot/ws-core-components';
import styles from './Calendar.module.scss';
import DaysList from './DaysList';
import WeekDays from './WeekDays';
export interface State {
    month: number;
    day: number;
    year: number;
}

export interface Props {
    minDate: Array<number>;
    getDateClassname?: (day: number, month: number, year: number) => string;
}

class Calendar extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            month: new Date().getMonth(),
            day: new Date().getDay(),
            year: new Date().getFullYear(),
        };
    }

    setNextMonth(): void {
        const nextMonth = (this.state.month + 1) % 12;
        this.setState({
            month: nextMonth,
            year: nextMonth === 0 ? this.state.year + 1 : this.state.year,
        });
    }

    setPrevMonth(): void {
        const prevMonth = (this.state.month + (12 - 1)) % 12;
        this.setState({
            month: prevMonth,
            year: prevMonth === 11 ? this.state.year - 1 : this.state.year,
        });
    }

    setMonth(month: number): void {
        this.setState({
            month,
        });
    }

    setYear(year: number): void {
        this.setState({
            year,
        });
    }

    render() {
        const { getDateClassname } = this.props;
        const { month, year } = this.state;
        const nextMonth = (month + 1) % 12;
        const nextYear = nextMonth === 0 ? this.state.year + 1 : this.state.year;

        return (
            <div className={styles.calendar}>
                <button className={styles.btnPrev} onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => this.setPrevMonth()}>
                    <ArrowLeftIcon />
                </button>
                <button className={styles.btnNext} onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => this.setNextMonth()}>
                    <ArrowRightIcon />
                </button>
                <div className={styles.month}>
                    <span className={styles.monthName}>
                        {getMonthName(this.state.month)} {this.state.year}
                    </span>
                    <WeekDays />
                    <DaysList month={month} year={year} getDateClassname={getDateClassname} />
                </div>
                <div className={styles.month}>
                    <span className={styles.monthName}>
                        {getMonthName(nextMonth)} {nextYear}
                    </span>
                    <WeekDays />
                    <DaysList month={nextMonth} year={nextYear} getDateClassname={getDateClassname} />
                </div>
            </div>
        );
    }
}

export default Calendar;
